import Button from '.';
import { ButtonProps } from './Button';

const PrimaryButton = (props: ButtonProps) => {
	return <Button variant='filled' color='primary' size='lg' {...props} />;
};

export default PrimaryButton;
